import frame from './SearchTitle.vue'
const SearchTitle = {
  install: function (Vue) {
    Vue.component('SearchTitle', frame)
  }
}
export default SearchTitle
